import styled from 'styled-components';

import { settings } from 'config';
import { colors } from 'config/theme';

const { MAINTENANCE_BANNER_SHOW } = settings.maintenance_banner;
const maintenanceBannerHeight = MAINTENANCE_BANNER_SHOW ? '24px' : '0px';

export const TableWrapper = styled.div`
  overflow-x: hidden;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  // view height - (banner + header + CUI banners + maintenance banner)
  height: calc(100vh - (36px + 66px + 46px + ${maintenanceBannerHeight}));

  @media screen and (max-width: 700px) {
    height: calc(100vh - (51px + 58px));
  }

  .table {
    border-collapse: collapse;
    overflow: auto;
    height: 100%;
    > * {
      min-width: fit-content;
    }

    .thead {
      position: sticky;
      z-index: 100;
      top: 0;
      .tr {
        background: white;
        background-color: ${colors.lightestGray};

        .th {
          position: relative;
          text-align: center;
          padding: 0.75rem 0.35rem 0.3rem 0.35rem;
          font-size: 0.9rem;
          color: ${colors.darkerGray};
          border-right: 1px solid ${colors.lightGray};
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: space-between;
          overflow-x: hidden;
          svg {
            flex-shrink: 0;
          }
          .wrapper {
            width: 100%;
          }

          &:last-child {
            border-right: none;

            .resizer {
              width: 5px;
              transform: none;
            }
          }
          &.filter {
            padding-top: 0rem;
            padding-bottom: 0.8rem;
            border-bottom: 1px solid ${colors.lightGray};
            > div {
              .MuiInputBase-input {
                cursor: pointer;
                padding: 0.75rem;
              }
              height: 2.4rem;
              margin: unset;
              padding: unset;
            }
            > input {
              height: 100%;
              background-size: 10%;
              background-position: calc(100% - 0.68em);
            }
          }

          .resizer {
            display: inline-block;
            width: 10px;
            height: 100%;
            position: absolute;
            right: 0;
            top: 0;
            transform: translateX(50%);
            z-index: 100;
            touch-action: none;
          }
        }
      }
    }
    .tbody {
      .tr {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e5e5e5;
        &:last-child {
          border-bottom: none;
        }
        .td {
          padding: 0.5rem 0.35rem;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          font-size: 1rem;
          &:last-child {
            border-right: none;
          }
        }
        .inspect {
          text-decoration: underline #1976d2;
        }

        &.checked {
          background-color: ${colors.lightBlue};
        }
      }
    }
  }
  .pagination {
    align-items: center;
    background-color: ${colors.lightestGray};
    border-top: 1px solid ${colors.lightGray};
    display: flex;
    justify-content: center;

    * {
      color: #263238;
      font-size: 14px;
    }

    > div {
      align-items: center;
      display: flex;
      justify-content: space-evenly;
      padding: 16px 0;

      > * {
        &:first-child {
          padding-right: 91px;
        }
        &:last-child {
          padding-left: 50px;
        }
      }

      @media screen and (max-width: 900px) {
        flex-flow: column;

        > * {
          &:first-child {
            padding-right: unset;
          }
          &:last-child {
            padding: 15px 0;
          }
        }

        nav {
          order: 1;
        }
      }

      .pageSelect {
        align-items: baseline;
        display: flex;
      }

      .MuiInputBase-root {
        margin-left: 1em;

        &::before,
        &::after {
          display: none;
        }

        div {
          width: min-content;

          &:focus {
            background-color: unset;
          }
        }

        svg {
          fill: #979797;
          right: 0.5em;
        }
      }
    }
  }
`;

export const MessageRow = styled.div`
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.lightBlue};
  color: ${colors.orange};
  min-width: 100%;
  u {
    cursor: pointer;
  }
`;

export const ControlWrapper = styled.div<{ ml: number }>`
  display: flex;
  flex: 150 0 auto;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  background-color: white;
  padding-left: ${({ ml }) => ml}px;
  button {
    text-decoration: underline !important;
    text-transform: unset;
    margin: 8px 0px;
    font-size: 0.8em;
  }
  .select-counter {
    background-color: ${colors.lighterGray};
    color: ${colors.blue};
    box-shadow: none;
    text-decoration: unset !important;
    margin-left: 0.5em;
    padding: 0 1.25em;
    .MuiButton-startIcon {
      > span {
        font-size: inherit;
      }
      margin-right: 4px;
    }
    &:disabled {
      color: ${colors.darkGray};
      visibility: hidden;
    }
  }
`;

export const CheckboxWrapper = styled.span`
  width: 50px;
  padding: 0.5rem 0.35rem;

  span input:disabled ~ svg {
    border-radius: 0.2em;
    background-color: ${colors.lightGray};
    fill: transparent;
    scale: 80%;
  }
`;
